import api from "./api";

const namespaced = true;

const state = {};

const mutations = {};

const actions = {
  getTripInclusion({ commit }, { env }) {
    return api
      .getTripInclusion(env)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
  updateTripInclusion({ commit }, { env, included, excluded, disclaimer }) {
    return api
      .updateTripInclusion(env, included, excluded, disclaimer)
      .then((data) => data.data)
      .catch((err) => {
        if (err) throw err.data;
      });
  },
};

const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
